module.exports = __webpack_public_path__ + "images/35ec4895d242bcc7921cb3985f539cd4.png";


//////////////////
// WEBPACK FOOTER
// ../public/images/bow.png
// module id = 1092
// module chunks = 0